import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTonConnectUI } from "@tonconnect/ui-react";
import { isTelegramMiniApp } from "../utils/platform";

/**
 * Куда кошелёк возвращает человека после подключения или подписи в браузере и PWA.
 *
 * TonConnect UI по умолчанию использует returnStrategy 'back', и на Android в
 * браузере превращает его в 'googlechrome://' — кошелёк просто выводит Chrome
 * на передний план с последней открытой вкладкой. Из установленного PWA это
 * выглядит как «выкинуло на старую страницу». Поэтому возвращаем ссылку на
 * текущий экран: её открывает установленное приложение (или новая вкладка с
 * тем же экраном). На десктопе возвращать некуда — там 'none'.
 *
 * В мини-аппе не делаем ничего: там работает twaReturnUrl из index.tsx.
 */
export function browserReturnStrategy(): `${string}://${string}` | "none" {
  if (typeof window === "undefined") return "none";
  const mobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  if (!mobile) return "none";
  return window.location.href as `${string}://${string}`;
}

const TonReturnStrategySync: React.FC = () => {
  const location = useLocation();
  const [, setOptions] = useTonConnectUI();

  useEffect(() => {
    if (isTelegramMiniApp) return;
    setOptions({ actionsConfiguration: { returnStrategy: browserReturnStrategy() } });
  }, [location.pathname, location.search, setOptions]);

  return null;
};

export default TonReturnStrategySync;
